import { useState } from 'react';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';

import { listenPush } from './index';
import { useComponentDidMount } from 'modules/core/hooks';
import Button from 'modules/core/components/buttons/Button';

interface PushAlertProps {
  /** Профиль из Redux (state.auth.profile). */
  user?: any;
}

const PushAlert = ({ user }: PushAlertProps) => {
  const [show, setShow] = useState(false);

  const isLocalhost = () => {
    return ['localhost', '127.0.0.1', '0.0.0.0'].includes(window.location.hostname);
  };

  const allowPush = async () => {
    await listenPush(user?.customerId);
    setShow(false);
  };

  useComponentDidMount(() => {
    if ('permissions' in navigator) {
      navigator.permissions
        .query({ name: 'notifications' })
        .then((notificationPerm) => {
          // eslint-disable-next-line no-param-reassign
          notificationPerm.onchange = () => {
            setShow(false);
          };
        });
    }

    if (!isLocalhost() && window.Notification?.permission === 'default') {
      setShow(true);
    }
  });

  return show && (
    <Alert variant='warning' className='push-alert'>
      Пожалуйста, разрешите пуш-уведомления для быстрого получения важной информации.
      <Button
        variant='primary'
        onClick={ allowPush }
        className='push-alert__button'
      >
        Включить
      </Button>
    </Alert>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.auth?.profile,
});

export default connect(mapStateToProps)(PushAlert);
